import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@material-ui/core';
import styled from 'styled-components';
import { em } from 'polished';
import { appTheme } from '../../../theme';
import CloseButton from '../CloseButton';
import PageTitle from '../PageTitle';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const FormSectionDivider = styled(Divider)`
  margin-top: ${em(appTheme.spacing.xlarge)};
`;

function FormSectionHeader({ onRemove, title }) {
  return (
    <div>
      <FormSectionDivider />
      <Wrapper>
        <PageTitle>{title}</PageTitle>
        <CloseButton onClick={onRemove} />
      </Wrapper>
    </div>
  );
}

FormSectionHeader.propTypes = {
  onRemove: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default FormSectionHeader;



// WEBPACK FOOTER //
// ./src/modules/common/form/FormSectionHeader.js